export const ACCEPT_LANGUAGE = 'accept-language';
export const ATP_CLUSTER_ID = 'x-atp-cluster-id';
export const AUTHORIZATION = 'authorization';
export const CHANNEL_TYPE = 'x-client-channel';
export const CLIENT_APPLICATION = 'x-client-application';
export const CONTENT_TYPE = 'content-type';
export const CUSTOMER_CONTEXT = 'x-customer-context';
export const CUSTOMER_TYPE_ID = 'x-customer-type-id';
export const PREVIEW_MODE = 'x-preview-mode';
export const TENANT_CONTEXT = 'x-tenant-context';
export const USE_PRODUCT_DATA_CACHING = 'x-use-product-data-caching';
export const USE_PRODUCTS_SERVICE = 'x-use-products-service';
export const VISITOR_SEGMENT = 'x-visitor-segment';
//# sourceMappingURL=headers.js.map